import { render } from "./upcomingItem.vue?vue&type=template&id=f9251fce&scoped=true"
import script from "./upcomingItem.vue?vue&type=script&lang=js"
export * from "./upcomingItem.vue?vue&type=script&lang=js"

import "./upcomingItem.vue?vue&type=style&index=0&id=f9251fce&lang=less&scoped=true"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9251fce"]])

export default __exports__